/**
 * Converts comment/message text to safe HTML for rendering.
 * Handles: markdown links, plain URLs, newlines, and passes through existing HTML.
 */
export function renderCommentHtml(text) {
  if (!text) return '';

  let html = text;

  // Convert markdown images: ![alt](url)
  html = html.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, 
    '<img src="$2" alt="$1" class="max-w-full h-auto rounded my-2" />');

  // Convert markdown links: [text](url)
  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, 
    '<a href="$2" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline break-all">$1</a>');

  // Convert plain URLs (not already inside href or src attributes)
  html = html.replace(/(?<!="|'>)(https?:\/\/[^\s<"']+)/g, (match) => {
    // Skip if this URL is already part of an href or src
    return `<a href="${match}" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline break-all">${match}</a>`;
  });

  // Fix double-linked URLs (URLs that were already in markdown links then caught by plain URL regex)
  html = html.replace(/<a [^>]*href="([^"]*)"[^>]*><a [^>]*href="[^"]*"[^>]*>([^<]*)<\/a><\/a>/g, 
    '<a href="$1" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline break-all">$2</a>');

  // Convert newlines to <br> (but not inside HTML tags)
  html = html.replace(/\n/g, '<br/>');

  // Convert markdown bold: **text** or __text__
  html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/__([^_]+)__/g, '<strong>$1</strong>');

  // Convert markdown italic: *text* or _text_ (but not inside URLs)
  html = html.replace(/(?<![/\w])\*([^*]+)\*(?![/\w])/g, '<em>$1</em>');

  return html;
}
